export default __webpack_public_path__ + "static/Lapwing-80c0ab98fb0c06ac5e20ed0948be36f6.jpeg";